import request from '../../common/services/proxy.service'

export function deptList(data) {
    return request({
        url: '/base/dept/query-all',
        method: 'post',
        data: data
    })
}
export function userDetail(data) {
    return request({
        url: '/base/user/query-user-by-id',
        method: 'post',
        data: data
    })
}
//获取随机id
export function getId(data) {
    return request({
        url: '/base/get-id',
        method: 'post',
        data: data
    })
}
//批量上传
export function uploadFileBatch(data) {
    return request({
        url: '/base/file/upload-file-batch',
        method: 'post',
        data: data
    })
}
//文件获取
export function queryFileBatch(data) {
    return request({
        url: '/base/file/query-file',
        method: 'post',
        data: data
    })
}
//文件下载
export function downloadFile(data) {
    return request({
        url: '/base/file/download-file',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}
//文件删除
export function deleFile(data) {
    return request({
        url: '/base/file/delete-file',
        method: 'post',
        data: data
    })
}
export function List(data) {}
// 菜单列表查询

export function menuList(data) {
    return request({
        url: 'base/menu/query-all',
        method: 'post',
        data: data
    })
}
//字典列表查询
export function dictList(data) {
    return request({
        url: 'base/dict/query-dict-type',
        method: 'post',
        data: data
    })
}

//字典新增
export function dictAdd(data) {
    return request({
        url: 'base/dict/add-dict-type',
        method: 'post',
        data: data
    })
}

// 菜单新增
export function menuAdd(data) {
    return request({
        url: 'base/menu/add-menu',

        method: 'post',
        data: data
    })
}

//字典修改
export function dictUpadte(data) {
    return request({
        url: 'base/dict/update-dict-type',
        method: 'post',
        data: data
    })
}
//字典删除
export function dictDele(data) {
    return request({
        url: 'base/dict/delete-dict-type',
        method: 'post',
        data: data
    })
}


//字典分页查询
export function pagedictList(data) {
    return request({
        url: 'base/dict/query-dict',
        method: 'post',
        data: data
    })
}
//字典新增
export function pagedictAdd(data) {
    return request({
        url: 'base/dict/add-dict',
        method: 'post',
        data: data
    })
}
//字典修改
export function pagedictUpdate(data) {
    return request({
        url: 'base/dict/update-dict',
        method: 'post',
        data: data
    })
}
//字典删除
export function pagedictDel(data) {
    return request({
        url: 'base/dict/delete-dict',
        method: 'post',
        data: data
    })
}
//部门新增
export function deptAdd(data) {
    return request({
        url: 'base/dept/add-dept',
        method: 'post',
        data: data
    })
}
//部门删除
export function deptDelete(data) {
    return request({
        url: 'base/dept/delete-dept',
        method: 'post',
        data: data
    })
}
//部门列表查询
export function deptQuery(data) {
    return request({
        url: 'base/dept/query-all',
        method: 'post',
        data: data
    })
}
//部门修改
export function deptUpdate(data) {
    return request({
        url: 'base/dept/update-dept',
        method: 'post',
        data: data
    })
}
//套餐分页查询
// export function queryList(data) {
//     return request({
//         url: 'packg/ser-center-pg/query-ser-center-pg',
//         method: 'post',
//         data: data
//     })
// }
//套餐新增
// export function addSer(data) {
//     return request({
//         url: 'packg/ser-center-pg/add-ser-center-pg',
//         method: 'post',
//         data: data
//     })
// }
//套餐删除
// export function deleteSer(data) {
//     return request({
//         url: 'packg/ser-center-pg/delete-ser-center-pg',
//         method: 'post',
//         data: data
//     })
// }
//套餐修改
// export function updateSer(data) {
//     return request({
//         url: 'packg/ser-center-pg/update-ser-center-pg',
//         method: 'post',
//         data: data
//     })
// }
//禁用启用
export function serStatus(data) {
    return request({
        url: 'packg/ser-center-pg/update-pg-status',
        method: 'post',
        data: data
    })
}
//客户分页查询
export function cusQuery(data) {
    return request({
        url: 'base/custom/query-custom',
        method: 'post',
        data: data
    })
}
//根据客户查询患者列表
export function patQuery(data) {
    return request({
        url: 'base/patient/query',
        method: 'post',
        data: data
    })
}
//根据患者id查询权益列表
export function custQuery(data) {
    return request({
        url: 'base/custom/query-custom-member',
        method: 'post',
        data: data
    })
}
//获取客户套餐记录
export function qcpQuery(data) {
    return request({
        url: 'base/custom/query-custom-pg',
        method: 'post',
        data: data
    })
}
//获取客户套餐记录及明细
export function qcpdQuery(data) {
    return request({
        url: 'base/custom/query-custom-pg-detail',
        method: 'post',
        data: data
    })
}
//根据患者id查询入院诊断
export function diagQuery(data) {
    return request({
        url: 'base/diagnosis/query-by-pat-id',
        method: 'post',
        data: data
    })
}
//根据患者查询病历档案
export function medQuery(data) {
    return request({
        url: 'base/med-records/query-by-pat-id',
        method: 'post',
        data: data
    })
}
//获取套餐中心详情
// export function serByid(data) {
//     return request({
//         url: 'packg/ser-center-pg/query-by-id',
//         method: 'post',
//         data: data
//     })
// }
//获取角色详情列表
export function roleId(data) {
    return request({
        url: 'base/role/query-by-id',
        method: 'post',
        data: data
    })
}

//获取字典详情列表
export function dictId(data) {
    return request({
        url: 'base/dict/query-dict-type-by-id',
        method: 'post',
        data: data
    })
}
//获取字典项详情列表
export function dictById(data) {
    return request({
        url: 'base/dict/query-dict-by-id',
        method: 'post',
        data: data
    })
}
//获取部门详情列表
export function deptId(data) {
    return request({
        url: 'base/dept/query-by-id',
        method: 'post',
        data: data
    })
}
//获取部门详情列表
export function Queryrefund(data) {
    return request({
        url: 'base/refund-apply/query-all',
        method: 'post',
        data: data
    })
}
//获取客户会员关联记录
export function Querycmrel(data) {
    return request({
        url: '/base/custom/query-custom-mem-rel',
        method: 'post',
        data: data
    })
}
//获取客户会员关联记录
export function Querycmequ(data) {
    return request({
        url: 'base/custom/query-custom-mem-equ',
        method: 'post',
        data: data
    })
}
//获取客户会员关联记录
export function Querycmconequ(data) {
    return request({
        url: '/base/custom/query-custom-consume-equ',
        method: 'post',
        data: data
    })
}

//退款申请
export function Refundapply(data) {
    return request({
        url: '/base/refund-apply/add-by-manage',
        method: 'post',
        data: data
    })
}
//根据ID查询退费申请
export function queryId(data) {
    return request({
        url: 'base/refund-apply/query-by-id',
        method: 'post',
        data: data
    })
}
//退费计算扣除
export function queryd(data) {
    return request({
        url: 'base/refund-apply/deduction',
        method: 'post',
        data: data
    })
}
//审核
export function shenhe(data) {
    return request({
        url: 'base/refund-apply/review',
        method: 'post',
        data: data
    })
}
//审核通过后退款
export function refar(data) {
    return request({
        url: 'base/refund-apply/refund',
        method: 'post',
        data: data
    })
}
//根据ID查询患者
export function patientId(data) {
    return request({
        url: 'base/patient/query-by-id',
        method: 'post',
        data: data
    })
}
//会员权益列表查询
export function memberQuery(data) {
    return request({
        url: 'packg/member-info/query-list',
        method: 'post',
        data: data
    })
}

//查询支付账单
export function queryPayBillList(data) {
    return request({
        url: '/base/bill/query-pay-bill-list',
        method: 'post',
        data: data
    })
}

//查询支付账单
export function queryExchange(data) {
    return request({
        url: '/packg/equity-good/query-exchange',
        method: 'post',
        data: data
    })
}

//修改权益兑换
export function updateExchange(data) {
    return request({
        url: '/packg/equity-good/update-exchange',
        method: 'post',
        data: data
    })
}

//查询用户消费过的记录
export function getUseRecord(data) {
    return request({
        url: '/base/refund-apply/get-use-record',
        method: 'post',
        data: data
    })
}

//退款详情
export function refundInfo(data) {
    return request({
        url: '/base/refund-apply/refund-info',
        method: 'post',
        data: data
    })
}

//用户管理-解除冻结
export function unlockUser(data) {
    return request({
        url: '/base/user/unlock-user',
        method: 'post',
        data: data
    })
}

//用户管理-重置密码
export function resetPwd(data) {
    return request({
        url: '/base/user/reset-pwd',
        method: 'post',
        data: data
    })
}

//客户管理-患者信息
export function queryPatient(data) {
    return request({
        url: '/base/patient/query-patient',
        method: 'post',
        data: data
    })
}



















//查询指定角色的菜单列表
export function queryMenu(data) {
    return request({
        url: 'base/role/query-menu-by-role',
        method: 'post',
        data: data
    })
}
//为角色分配菜单
export function fenpeiMenu(data) {
    return request({
        url: 'base/role/add-role-menu',
        method: 'post',
        data: data
    })
}
//为指定角色分配用户列表
export function roleuser(data) {
    return request({
        url: 'base/role/add-role-users',
        method: 'post',
        data: data
    })
}


// 菜单编辑  
export function menuUpdate(data) {
    return request({
        url: 'base/menu/update-menu',

        method: 'post',
        data: data
    })
}

// 单个菜单删除
export function menuDelone(data) {
    return request({
        url: 'base/menu/delete-menu-by-id',
        method: 'post',
        data: data
    })
}

//分页查询角色列表
export function queryRoleList(data) {
    return request({
        url: '/base/role/query-role',
        method: 'post',
        data: data
    })
}

//新增角色
export function addRoleData(data) {
    return request({
        url: '/base/role/add-role',
        method: 'post',
        data: data
    })
}

//删除角色
export function deleteRole(data) {
    return request({
        url: '/base/role/delete-role-by-id',
        method: 'post',
        data: data
    })
}

//修改角色
export function updateRole(data) {
    return request({
        url: '/base/role/update-role',
        method: 'post',
        data: data
    })
}

//修改角色状态
export function updateRoleStatus(data) {
    return request({
        url: '/base/role/update-role-status',
        method: 'post',
        data: data
    })
}

//查询指定角色未分配的用户
export function queryUserNoOwn(data) {
    return request({
        url: '/base/role/query-user-no-own',
        method: 'post',
        data: data
    })
}

//查询指定角色的全部用户
export function queryUserByRole(data) {
    return request({
        url: '/base/role/query-user-by-role',
        method: 'post',
        data: data
    })
}

//为指定角色分配用户列表
export function addRoleUsers(data) {
    return request({
        url: '/base/role/add-role-users',
        method: 'post',
        data: data
    })
}

//删除指定角色下的用户列表
export function deleteRoleUsers(data) {
    return request({
        url: '/base/role/delete-role-users',
        method: 'post',
        data: data
    })
}

//客户注册分页查询
export function queryRegisterCus(data) {
    return request({
        url: '/base/custom/query-register-custom',
        method: 'post',
        data: data
    })
}

//客户管理-审核通过
export function reviewAgree(data) {
    return request({
        url: '/base/custom/review-agree',
        method: 'post',
        data: data
    })
}

//客户管理-审核拒绝
export function reviewReject(data) {
    return request({
        url: '/base/custom/review-reject',
        method: 'post',
        data: data
    })
}

//客户管理-批量审核通过
export function reviewAgreeBatch(data) {
    return request({
        url: '/base/custom/review-agree-batch',
        method: 'post',
        data: data
    })
}

//客户管理-批量审核通过
export function reviewRejectBatch(data) {
    return request({
        url: '/base/custom/review-reject-batch',
        method: 'post',
        data: data
    })
}

//账户管理-分页查询账户
export function accountQueryAll(data) {
    return request({
        url: '/base/account/query-all',
        method: 'post',
        data: data
    })
}

//账户管理-分页查询账户余额大于0的账户
export function accountQueryList(data) {
    return request({
        url: '/base/account/query-list',
        method: 'post',
        data: data
    })
}

//账户管理-账户充值
export function recharge(data) {
    return request({
        url: '/base/account/recharge',
        method: 'post',
        data: data
    })
}

//账户管理-通过openid查询账户
export function queryByOpenid(data) {
    return request({
        url: '/base/account/query-by-openid',
        method: 'post',
        data: data
    })
}

//账户管理-通过openid查询账户
export function accountRefund(data) {
    return request({
        url: '/base/account/refund',
        method: 'post',
        data: data
    })
}

//账户账单-查询账户账单
export function rechargeBillQuery(data) {
    return request({
        url: '/base/rechargeBill/query-all',
        method: 'post',
        data: data
    })
}

//机构列表查询
export function institutionsLIst(data) {
    return request({
        url: '/hxxt-manager/organ/query',
        method: 'post',
        data: data
    })
}
//机构新增
export function institutionsAdd(data) {
    return request({
        url: '/hxxt-manager/organ/add',
        method: 'post',
        data: data
    })
}
//机构修改
export function institutionsUpdate(data) {
    return request({
        url: '/hxxt-manager/organ/update',
        method: 'post',
        data: data
    })
}
//机构删除
export function institutionsdelete(data) {
    return request({
        url: '/hxxt-manager/organ/delete',
        method: 'post',
        data: data
    })
}
//机构ID查询
export function institutionsquerybyid(data) {
    return request({
        url: '/hxxt-manager/organ/querybyid',
        method: 'post',
        data: data
    })
}
//行政区划查询
export function Administrativequery(data) {
    return request({
        url: '/hxxt-manager/adiv/query',
        method: 'post',
        data: data
    })
}
//理财师修改密码
export function accountupdatepassword(data) {
    return request({
        url: '/hxxt-manager/account/update-password',
        method: 'post',
        data: data
    })
}
//理财师重置密码
export function accountresetpassword(data) {
    return request({
        url: '/hxxt-manager/account/reset-password',
        method: 'post',
        data: data
    })
}
//登录用户修改密码
export function userupdatepassword(data) {
    return request({
        url: '/base/user/update-password',
        method: 'post',
        data: data
    })
}

//客户管理-根据ID查询病历档案
export function queryByIdMed(data) {
    return request({
        url: '/base/med-records/query-by-id',
        method: 'post',
        data: data
    })
}



//重置密码
export function userresetpassword(data) {
    return request({
        url: '/hxxt-manager/user/reset-password',
        method: 'post',
        data: data
    })
}
//推广列表查询
export function extensionquery(data) {
    return request({
        url: '/hxxt-manager/popular/query',
        method: 'post',
        data: data
    })
}
//推广新增
export function extensionAdd(data) {
    return request({
        url: '/hxxt-manager/popular/add',
        method: 'post',
        data: data
    })
}
//查看二维码
export function QRcode(data) {
    return request({
        url: '/hxxt-manager/popular/create_code',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}
//账号列表查询
export function accountquery(data) {
    return request({
        url: '/hxxt-manager/account/query',
        method: 'post',
        data: data
    })
}
//发行方案列表
export function rlsePlanquery(data) {
    return request({
        url: '/hxxt-manager/rlsePlan/query',
        method: 'post',
        data: data
    })
}
//H5推广链接-禁用启用
export function popularupdate(data) {
    return request({
        url: '/hxxt-manager/popular/update',
        method: 'post',
        data: data
    })
}
//账号修改
export function accountupdate(data) {
    return request({
        url: '/hxxt-manager/account/update',
        method: 'post',
        data: data
    })
}
//账号新增
export function accountAdd(data) {
    return request({
        url: '/hxxt-manager/account/add',
        method: 'post',
        data: data
    })
}
//待审核签约列表查询
export function signquery(data) {
    return request({
        url: '/hxxt-manager/sign/query',
        method: 'post',
        data: data
    })
}
//待审核签约列表查询
export function signquerys(data) {
    return request({
        url: '/hxxt-manager/sign/querys',
        method: 'post',
        data: data
    })
}
//查看详情-客户基本信息
export function signquerybyidcus(data) {
    return request({
        url: '/hxxt-manager/sign/query-byid-cus',
        method: 'post',
        data: data
    })
}
//查看影像
export function signquerypactbyid(data) {
    return request({
        url: '/hxxt-manager/sign/query-pact-byid',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//查看影像
export function signexporttainfo(data) {
    return request({
        url: `/hxxt-manager/sign/export-tainfo?idList=${data}`,
        method: 'get',
        responseType: 'blob',
    })
}
//文件下载-投资认证模板
export function imagemangdownloadident() {
    return request({
        url: '/hxxt-manager/image-mang/download-ident',
        method: 'get',
        responseType: 'blob',
    })
}
//话术模板内容查询
export function scpConquery(data) {
    return request({
        url: '/hxxt-manager/scpCon/query',
        method: 'post',
        data: data
    })
}
//话术模板内容新增
export function scpConAdd(data) {
    return request({
        url: '/hxxt-manager/scpCon/add',
        method: 'post',
        data: data
    })
}
//话术模板内容编辑
export function scpConupdate(data) {
    return request({
        url: '/hxxt-manager/scpCon/update',
        method: 'post',
        data: data
    })
}
//话术模板内容删除
export function scpCondelete(data) {
    return request({
        url: '/hxxt-manager/scpCon/delete',
        method: 'post',
        data: data
    })
}
//评分标准查询
export function questionnairescore(data) {
    return request({
        url: '/hxxt-manager/questionnaire/score',
        method: 'post',
        data: data
    })
}
//评分标准添加
export function questionnairescoreadd(data) {
    return request({
        url: '/hxxt-manager/questionnaire/score-add',
        method: 'post',
        data: data
    })
}
//评分标准修改
export function questionnairescoreupdate(data) {
    return request({
        url: '/hxxt-manager/questionnaire/score-update',
        method: 'post',
        data: data
    })
}
//话术管理列表查询
export function scpquery(data) {
    return request({
        url: '/hxxt-manager/scp/query',
        method: 'post',
        data: data
    })
}
//话术管理删除
export function scpdelete(data) {
    return request({
        url: '/hxxt-manager/scp/delete',
        method: 'post',
        data: data
    })
}
//话术管理新增
export function scpadd(data) {
    return request({
        url: '/hxxt-manager/scp/add',
        method: 'post',
        data: data
    })
}
//风险适应调查表
export function signexportriske(data) {
    return request({
        url: '/hxxt-manager/sign/export-riske',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//话术管理编辑
export function scpupdate(data) {
    return request({
        url: '/hxxt-manager/scp/update',
        method: 'post',
        data: data
    })
}
//问卷查询
export function questionnairequery(data) {
    return request({
        url: '/hxxt-manager/questionnaire/query',
        method: 'post',
        data: data
    })
}
//问卷新增
export function questionnaireAdd(data) {
    return request({
        url: '/hxxt-manager/questionnaire/add',
        method: 'post',
        data: data
    })
}
//问卷新增
export function questionnaireupdate(data) {
    return request({
        url: '/hxxt-manager/questionnaire/update',
        method: 'post',
        data: data
    })
}
//根据问题Id查询答案
export function answerquery(data) {
    return request({
        url: '/hxxt-manager/answer/query',
        method: 'post',
        data: data
    })
}
//根据问题Id查询答案
export function questionnairequestionquery(data) {
    return request({
        url: '/hxxt-manager/questionnaire/question-query',
        method: 'post',
        data: data
    })
}
//题库修改
export function questionupdate(data) {
    return request({
        url: '/hxxt-manager/question/update',
        method: 'post',
        data: data
    })
}
//题库查询
export function questionquery(data) {
    return request({
        url: '/hxxt-manager/question/query',
        method: 'post',
        data: data
    })
}
//题目状态,1下线,0正常
export function questiondel(data) {
    return request({
        url: '/hxxt-manager/question/del',
        method: 'post',
        data: data
    })
}
//题库新增
export function questionAdd(data) {
    return request({
        url: '/hxxt-manager/question/add',
        method: 'post',
        data: data
    })
}
//签约审核
export function signupdate(data) {
    return request({
        url: '/hxxt-manager/sign/update',
        method: 'post',
        data: data
    })
}
//复制链接
export function popularcreatecodecopy(data) {
    return request({
        url: '/hxxt-manager/popular/create_code_copy',
        method: 'post',
        data: data
    })
}
//合同盖章
export function esigningsealContract(data) {
    return request({
        url: '/hxxt-manager/esigning/sealContract',
        method: 'post',
        data: data
    })
}
export function userStatus(data) {
    return request({
        url: '/base/user/update-user-status',
        method: 'post',
        data: data
    })
}
//信托列表查询
export function projquery(data) {
    return request({
        url: '/hxxt-manager/proj/query',
        method: 'post',
        data: data
    })
}
//信托新增
export function projAdd(data) {
    return request({
        url: '/hxxt-manager/proj/add',
        method: 'post',
        data: data
    })
}
//信托修改
export function projupdate(data) {
    return request({
        url: '/hxxt-manager/proj/update',
        method: 'post',
        data: data
    })
}
//银行信息查询
export function bankquery(data) {
    return request({
        url: '/hxxt-manager/bank/query',
        method: 'post',
        data: data
    })
}
//收益列表查询
export function incomeLevquery(data) {
    return request({
        url: '/hxxt-manager/incomeLev/query',
        method: 'post',
        data: data
    })
}
//收益列表修改
export function incomeLevupdate(data) {
    return request({
        url: '/hxxt-manager/incomeLev/update',
        method: 'post',
        data: data
    })
}
//收益列表新增
export function incomeLevupAdd(data) {
    return request({
        url: '/hxxt-manager/incomeLev/add',
        method: 'post',
        data: data
    })
}
//添加对应角色
export function useraddrole(data) {
    return request({
        url: '/base/user/add-user-role',
        method: 'post',
        data: data
    })
}
//删除对应角色
export function userdelerole(data) {
    return request({
        url: '/base/user/delete-user-role',
        method: 'post',
        data: data
    })
}
//收益列表删除
export function incomeLevdelete(data) {
    return request({
        url: '/hxxt-manager/incomeLev/delete',
        method: 'post',
        data: data
    })
}
//发行方案通过ID查询单条数据
export function rlsePlanqueryById(data) {
    return request({
        url: '/hxxt-manager/rlsePlan/queryById',
        method: 'post',
        data: data
    })
}
//发行方案修改
export function rlsePlanAdd(data) {
    return request({
        url: '/hxxt-manager/rlsePlan/add',
        method: 'post',
        data: data
    })
}
//发行方案修改
export function rlsePlanupdate(data) {
    return request({
        url: '/hxxt-manager/rlsePlan/update',
        method: 'post',
        data: data
    })
}
//发行方案下架操作
export function rlsePlansoldOut(data) {
    return request({
        url: '/hxxt-manager/rlsePlan/soldOut',
        method: 'post',
        data: data
    })
}
//产品列表查询
export function pdmquery(data) {
    return request({
        url: '/hxxt-manager/pdm/query',
        method: 'post',
        data: data
    })
}
//产品修改
export function pdmupdate(data) {
    return request({
        url: '/hxxt-manager/pdm/update',
        method: 'post',
        data: data
    })
}
//产品新增
export function pdmadd(data) {
    return request({
        url: '/hxxt-manager/pdm/add',
        method: 'post',
        data: data
    })
}
//新增角色关联
export function ruserAdd(data) {
    return request({
        url: '/hxxt-manager/ruser/add',
        method: 'post',
        data: data
    })
}
//根据用户ID删除
export function ruserdeleteuser(data) {
    return request({
        url: '/hxxt-manager/ruser/deleteuser',
        method: 'post',
        data: data
    })
}
//角色列表查询
export function rolequery(data) {
    return request({
        url: '/hxxt-manager/role/query',
        method: 'post',
        data: data
    })
}
//角色列表查询
export function ruserqueryUserId(data) {
    return request({
        url: '/hxxt-manager/ruser/queryUserId',
        method: 'post',
        data: data
    })
}
//用户列表查询
export function userquery(data) {
    return request({
        url: '/base/user/query-user',
        method: 'post',
        data: data
    })
}

export function userbyrole(data) {
    return request({
        url: '/base/user/query-role-no-own',
        method: 'post',
        data: data
    })
}
export function userbyroles(data) {
    return request({
        url: '/base/user/query-role-by-user',
        method: 'post',
        data: data
    })
}
//用户列表查询
export function userdelete(data) {
    return request({
        url: '/base/user/delete-user-by-id',
        method: 'post',
        data: data
    })
}
//菜单授权列表
export function menulistempower(data) {
    return request({
        url: '/hxxt-manager/menu/list-empower',
        method: 'post',
        data: data
    })
}
//菜单授权
export function menuempower(data) {
    return request({
        url: '/hxxt-manager/menu/empower',
        method: 'post',
        data: data
    })
}
//角色权限列表
export function getrolesacct(data) {
    return request({
        url: '/hxxt-manager/role/get-roles-acct',
        method: 'post',
        data: data
    })
}
//角色权限
export function addroleacct(data) {
    return request({
        url: '/hxxt-manager/role/add-role-acct',
        method: 'post',
        data: data
    })
}
//数据权限列表
export function getrolesahr(data) {
    return request({
        url: '/hxxt-manager/role/get-roles-ahr',
        method: 'post',
        data: data
    })
}
//数据权限
export function addroledataahr(data) {
    return request({
        url: '/hxxt-manager/role/add-role-dataahr',
        method: 'post',
        data: data
    })
}
//用户角色列表
export function getroles(data) {
    return request({
        url: '/hxxt-manager/role/get-roles',
        method: 'post',
        data: data
    })
}
//用户角色
export function addrole(data) {
    return request({
        url: '/hxxt-manager/role/add-role',
        method: 'post',
        data: data
    })
}
//菜单列表查询
export function menuquery(data) {
    return request({
        url: '/hxxt-manager/menu/query',
        method: 'post',
        data: data
    })
}
//菜单列表树形结构
export function menulistedit(data) {
    return request({
        url: '/hxxt-manager/menu/list-edit',
        method: 'post',
        data: data
    })
}
//菜单删除
export function menudelete(data) {
    return request({
        url: '/hxxt-manager/menu/delete',
        method: 'post',
        data: data
    })
}
//角色ID查询
export function umenuqueryRoleId(data) {
    return request({
        url: '/hxxt-manager/umenu/queryRoleId',
        method: 'post',
        data: data
    })
}
//新增菜单关联
export function umenuaddMenu(data) {
    return request({
        url: '/hxxt-manager/umenu/addMenu',
        method: 'post',
        data: data
    })
}
//根据角色ID删除 
export function umenudeleteRoleid(data) {
    return request({
        url: '/hxxt-manager/umenu/deleteRoleid',
        method: 'post',
        data: data
    })
}
//角色删除 
export function roledelete(data) {
    return request({
        url: '/hxxt-manager/role/delete',
        method: 'post',
        data: data
    })
}
//数据字典类型列表查询
export function dicttpquery(data) {
    return request({
        url: '/hxxt-manager/dicttp/query',
        method: 'post',
        data: data
    })
}
//数据字典类型列表删除
export function dicttpdelete(data) {
    return request({
        url: '/hxxt-manager/dicttp/delete',
        method: 'post',
        data: data
    })
}
//数据字典列表查询
export function dictquery(data) {
    return request({
        url: '/hxxt-manager/dict/query',
        method: 'post',
        data: data
    })
}
//数据字典删除
export function dictdelete(data) {
    return request({
        url: '/hxxt-manager/dict/delete',
        method: 'post',
        data: data
    })
}
//成员组列表查询
export function memberGroupquery(data) {
    return request({
        url: '/hxxt-manager/memberGroup/query',
        method: 'post',
        data: data
    })
}
//角色ID查询
export function ruserqueryRoleId(data) {
    return request({
        url: '/hxxt-manager/ruser/queryRoleId',
        method: 'post',
        data: data
    })
}
//根据id集合查询用户列表
export function userquerybyids(data) {
    return request({
        url: '/hxxt-manager/user/querybyids',
        method: 'post',
        data: data
    })
}
//根据角色id新增角色关联
export function ruseraddById(data) {
    return request({
        url: '/hxxt-manager/ruser/addById',
        method: 'post',
        data: data
    })
}
//根据id集合查询菜单列表
export function menuquerybyids(data) {
    return request({
        url: '/hxxt-manager/menu/querybyids',
        method: 'post',
        data: data
    })
}
//根据id集合查询用户列表
export function memberquerybyids(data) {
    return request({
        url: '/hxxt-manager/member/querybyids',
        method: 'post',
        data: data
    })
}
//成员列表查询 
export function memberquery(data) {
    return request({
        url: '/hxxt-manager/member/query',
        method: 'post',
        data: data
    })
}
//成员组修改
export function memberGroupupdate(data) {
    return request({
        url: '/hxxt-manager/memberGroup/update',
        method: 'post',
        data: data
    })
}
//成员新增
export function memberAdd(data) {
    return request({
        url: '/hxxt-manager/member/add',
        method: 'post',
        data: data
    })
}
//成员组新增
export function memberGroupAdd(data) {
    return request({
        url: '/hxxt-manager/memberGroup/add',
        method: 'post',
        data: data
    })
}
//成员组ID查询
export function memberGroupqueryMemberGroupId(data) {
    return request({
        url: '/hxxt-manager/memberGroup/queryMemberGroupId',
        method: 'post',
        data: data
    })
}
//根据成员名集合查询成员列表
export function memberquerybymember(data) {
    return request({
        url: '/hxxt-manager/member/querybymember',
        method: 'post',
        data: data
    })
}
//根据菜单名集合查询菜单列表
export function menuquerybymenunm(data) {
    return request({
        url: '/hxxt-manager/menu/querybymenunm',
        method: 'post',
        data: data
    })
}
//根据ID删除
export function memberGroupdelete(data) {
    return request({
        url: '/hxxt-manager/memberGroup/delete',
        method: 'post',
        data: data
    })
}
//数据字典类型新增
export function dicttpadd(data) {
    return request({
        url: '/hxxt-manager/dicttp/add',
        method: 'post',
        data: data
    })
}
//数据字典类型修改
export function dicttpupdate(data) {
    return request({
        url: '/hxxt-manager/dicttp/update',
        method: 'post',
        data: data
    })
}
//数据字典新增
export function dictadd(data) {
    return request({
        url: '/hxxt-manager/dict/add',
        method: 'post',
        data: data
    })
}
//数据字典修改
export function dictupdate(data) {
    return request({
        url: '/hxxt-manager/dict/update',
        method: 'post',
        data: data
    })
}
//菜单新增
export function menuadd(data) {
    return request({
        url: '/hxxt-manager/menu/add',
        method: 'post',
        data: data
    })
}
//菜单修改
export function menuupdate(data) {
    return request({
        url: '/hxxt-manager/menu/update',
        method: 'post',
        data: data
    })
}
//角色新增
export function roleadd(data) {
    return request({
        url: '/hxxt-manager/role/add',
        method: 'post',
        data: data
    })
}
//角色修改
export function roleupdate(data) {
    return request({
        url: '/hxxt-manager/role/update',
        method: 'post',
        data: data
    })
}
//用户新增
export function useradd(data) {
    return request({
        url: '/base/user/add-user',
        method: 'post',
        data: data
    })
}
//用户修改
export function userupdate(data) {
    return request({
        url: '/base/user/update-user-by-id',
        method: 'post',
        data: data
    })
}
//认证管理列表查询
export function identquery(data) {
    return request({
        url: '/hxxt-manager/ident/query',
        method: 'post',
        data: data
    })
}
//批量审核
export function identupdate(data) {
    return request({
        url: '/hxxt-manager/ident/update',
        method: 'post',
        data: data
    })
}
//查看证明文件
export function identdownload(data) {
    return request({
        url: '/hxxt-manager/ident/download',
        method: 'post',
        data: data
    })
}
//下载证明文件
export function identdownloadident(data) {
    return request({
        url: '/hxxt-manager/ident/download-ident',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//文件路径查询
export function imagemangqueryurl(data) {
    return request({
        url: '/hxxt-manager/image-mang/query-url',
        method: 'post',
        data: data
    })
}
//文件下载-传文件地址
export function signbatchdownload(data) {
    return request({
        url: `/hxxt-manager/sign/batch-download?idList=${data}`,
        method: 'get',
        responseType: 'blob',
    })
}
//文件下载-传文件地址
export function imagemangdownload(data) {
    return request({
        url: '/hxxt-manager/image-mang/download',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//合同预览下载
export function contractdownloadRsp(data) {
    return request({
        url: '/hxxt-manager/contract/downloadRsp',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//发送邮件
export function signsendmail(data) {
    return request({
        url: '/hxxt-manager/sign/send-mail',
        method: 'post',
        data: data
    })
}
//确认到账
export function signconfreceipt(data) {
    return request({
        url: '/hxxt-manager/sign/conf-receipt',
        method: 'post',
        data: data
    })
}
//流水匹配
export function signflowmatcht(data) {
    return request({
        url: '/hxxt-manager/sign/flow-match',
        method: 'post',
        data: data
    })
}
//下载流水
export function signexportnoflow(data) {
    return request({
        url: '/hxxt-manager/sign/export-noflow',
        method: 'get',
        responseType: 'blob',
        params: data
    })
}
//合同模板上传
export function contractupload(data) {
    return request({
        url: '/hxxt-manager/contract/upload',
        method: 'post',
        data: data,
    })
}
//补充文件
export function identuploadimagefiles(data) {
    return request({
        url: '/hxxt-manager/ident/uploadimagefiles',
        method: 'post',
        data: data,
    })
}
//查询机构下发行方案列表
export function accountquerypdlist(data) {
    return request({
        url: '/hxxt-manager/account/query-pd-list',
        method: 'post',
        data: data
    })
}
//合同模板新增
export function contractAdd(data) {
    return request({
        url: '/hxxt-manager/contract/add',
        method: 'post',
        data: data
    })
}
//合同模板修改
export function contractupdate(data) {
    return request({
        url: '/hxxt-manager/contract/update',
        method: 'post',
        data: data
    })
}
//合同模板删除
export function contractdelete(data) {
    return request({
        url: '/hxxt-manager/contract/delete',
        method: 'post',
        data: data
    })
}
//合同签章信息修改
export function contractsignupdate(data) {
    return request({
        url: '/hxxt-manager/contract/sign-update',
        method: 'post',
        data: data
    })
}
//合同模板预览
export function contractpreview(data) {
    return request({
        url: '/hxxt-manager/contract/preview',
        method: 'post',
        data: data
    })
}
//合同模板列表查询
export function contractquery(data) {
    return request({
        url: '/hxxt-manager/contract/query',
        method: 'post',
        data: data
    })
}
//关联合同模板列表查询已合并的
export function contractqueryMerge(data) {
    return request({
        url: '/hxxt-manager/contract/queryMerge',
        method: 'post',
        data: data
    })
}
//合同因子新增
export function contractfactAdd(data) {
    return request({
        url: '/hxxt-manager/contract-fact/add',
        method: 'post',
        data: data
    })
}
//合同因子修改
export function contractfactupdate(data) {
    return request({
        url: '/hxxt-manager/contract-fact/update',
        method: 'post',
        data: data
    })
}
//合同因子删除
export function contractfactdelete(data) {
    return request({
        url: '/hxxt-manager/contract-fact/delete',
        method: 'post',
        data: data
    })
}
//合同因子列表查询
export function contractfactquery(data) {
    return request({
        url: '/hxxt-manager/contract-fact/query',
        method: 'post',
        data: data
    })
}
//账号查询对应子产品
export function accountquerybyid(data) {
    return request({
        url: '/hxxt-manager/account/querybyid',
        method: 'post',
        data: data
    })
}
//查询菜单详情ID
export function menuById(data) {
    return request({
        url: '/base/menu/query-by-id',
        method: 'post',
        data: data
    })
}
//文件上传
export function uploadFile(data) {
    return request({
        url: '/base/file/upload-file',
        method: 'post',
        data: data
    })
}
//新增轮播图
export function addRotationChart(data) {
    return request({
        url: '/seek/rotation-chart/add',
        method: 'post',
        data: data
    })
}
//查询轮播图列表
export function queryRotationChart(data) {
    return request({
        url: '/seek/rotation-chart/query-all',
        method: 'post',
        data: data
    })
}
//删除轮播图
export function delRotationChart(data) {
    return request({
        url: '/seek/rotation-chart/delete-by-id',
        method: 'post',
        data: data
    })
}
//修改轮播图
export function updateRotationChart(data) {
    return request({
        url: '/seek/rotation-chart/update-by-id',
        method: 'post',
        data: data
    })
}
//根据ID查询轮播图
export function gretRotationChartById(data) {
    return request({
        url: '/seek/rotation-chart/query-by-id',
        method: 'post',
        data: data
    })
}
//人工处理退款
export function updateByLabour(data) {
    return request({
        url: '/base/refund-apply/update-by-labour',
        method: 'post',
        data: data
    })
}
//列表查询入院诊断
export function queryDiagnosis(data) {
    return request({
        url: '/base/diagnosis/query-all',
        method: 'post',
        data: data
    })
}
//列表查询病历档案
export function queryMedRecords(data) {
    return request({
        url: '/base/med-records/query-all',
        method: 'post',
        data: data
    })
}
//返回默认密码
export function defaultPwd(data) {
    return request({
        url: '/base/user/def-pwd',
        method: 'post',
        data: data
    })
}
//赠送权益
export function giveEquity(data) {
    return request({
        url: '/packg/equity-good/give-equity-good',
        method: 'post',
        data: data
    })
}



//--------------------------------------------陪诊--------------------------------------------------------
//客户管理-客户信息分页查询
export function queryCustom(data) {
    return request({
        url: '/base/custom/query-custom',
        method: 'post',
        data: data
    })
}
//客户管理-冻结
export function lockCusUser(data) {
    return request({
        url: '/base/custom/lock-user',
        method: 'post',
        data: data
    })
}
//客户管理-解冻
export function unlockCusUser(data) {
    return request({
        url: '/base/custom/unlock-user',
        method: 'post',
        data: data
    })
}
//客户管理-黑名单分页查询
export function queryBlack(data) {
    return request({
        url: '/base/black-list/query-black',
        method: 'post',
        data: data
    })
}
//客户管理-黑名单新增数据
export function addBlack(data) {
    return request({
        url: '/base/black-list/add',
        method: 'post',
        data: data
    })
}
//客户管理-删除
export function deleteById(data) {
    return request({
        url: '/base/black-list/delete-by-id',
        method: 'post',
        data: data
    })
}
//客户管理-协议签署分页查询
export function queryAgreement(data) {
    return request({
        url: '/base/agreement-sign/query-agreement',
        method: 'post',
        data: data
    })
}
//客户管理-客户权益查询
export function queryCustGood(data) {
    return request({
        url: '/base/custom/query-cust-good',
        method: 'post',
        data: data
    })
}
//客户管理-客户权益-赠送权益
export function giveGood(data) {
    return request({
        url: '/base/custom/give-good',
        method: 'post',
        data: data
    })
}
//客户管理-企业管理-分页查询
export function queryListCompany(data) {
    return request({
        url: '/company/query-list',
        method: 'post',
        data: data
    })
}
//客户管理-企业管理-新增
export function addCompany(data) {
    return request({
        url: '/company/add',
        method: 'post',
        data: data
    })
}
//客户管理-企业管理-修改
export function updateCompany(data) {
    return request({
        url: '/company/update',
        method: 'post',
        data: data
    })
}
//客户管理-企业管理-删除
export function deleteByIdCompany(data) {
    return request({
        url: '/company/delete-by-id',
        method: 'post',
        data: data
    })
}
//客户管理-企业管理-查询详情
export function queryByIdCompany(data) {
    return request({
        url: '/company/query-by-id',
        method: 'post',
        data: data
    })
}
// 商品信息编辑
export function goodUpdate(data) {
    return request({
        url: '/packg/goodsInfo/update',
        method: 'post',
        data: data
    })
}
// 商品信息删除
export function goodDel(data) {
    return request({
        url: '/packg/goodsInfo/delete-by-id',
        method: 'post',
        data: data
    })
}
// 商品信息新增
export function goodAdd(data) {
    return request({
        url: '/packg/goodsInfo/add',
        method: 'post',
        data: data
    })
}
// 商品信息列表查询
export function goodList(data) {
    return request({
        url: '/packg/goodsInfo/query-goodsinfo',
        method: 'post',
        data: data
    })
}

// 查询商品单条数据
export function querygoodsById(data) {
    return request({
        url: '/packg/goodsInfo/query-by-id',
        method: 'post',
        data: data
    })
}

// 网点信息编辑
export function networkUpdate(data) {
    return request({
        url: '/packg/networkInfo/update-network',
        method: 'post',
        data: data
    })
}
// 网点信息删除
export function networkDel(data) {
    return request({
        url: '/packg/networkInfo/delete-network',
        method: 'post',
        data: data
    })
}
// 网点信息新增
export function networkAdd(data) {
    return request({
        url: '/packg/networkInfo/add-network',
        method: 'post',
        data: data
    })
}
// 网点信息列表查询
export function networkList(data) {
    return request({
        url: '/packg/networkInfo/query-networkInfo',
        method: 'post',
        data: data
    })
}

// 查询网点单条数据
export function querynetworkById(data) {
    return request({
        url: '/packg/networkInfo/query-by-id',
        method: 'post',
        data: data
    })
}
//服务管理-服务评价分页查询
export function queryEva(data) {
    return request({
        url: '/base/evaluate-info/query-eva',
        method: 'post',
        data: data
    })
}
//服务管理-服务评价详情
export function queryEvaInfoById(data) {
    return request({
        url: '/base/evaluate-info/query-by-id',
        method: 'post',
        data: data
    })
}
//分页查询客服服务列表(客户商品信息)
export function queryCustomGoodsPage(data) {
    return request({
        url: '/packg/goodsInfo/query-custom-goods',
        method: 'post',
        data: data
    })
}

//查询客户申请交付服务信息
export function queryDeliverCustgoods(data) {
    return request({
        url: '/packg/goodsInfo/query-deliver-custgoods',
        method: 'post',
        data: data
    })
}

//保存交付说明(完成交付)
export function saveDelivers(data) {
    return request({
        url: '/packg/goodsInfo/save-deliver',
        method: 'post',
        data: data
    })
}
//关闭申请服务
export function closeCustgoods(data) {
    return request({
        url: '/packg/goodsInfo/close-custom-goods',
        method: 'post',
        data: data
    })
}
//账户管理-交易对账-分页列表查询
export function queryTrade(data) {
    return request({
        url: '/pay/trade-recon/query-trade',
        method: 'post',
        data: data
    })
}
//账户管理-交易对账-查询详情
export function queryTradeById(data) {
    return request({
        url: '/pay/trade-recon/query-by-id',
        method: 'post',
        data: data
    })
}
//账户管理-交易对账-自动对账
export function tradeAuto(data) {
    return request({
        url: '/pay/trade-recon/trade-auto',
        method: 'post',
        data: data
    })
}
//账户管理-交易对账-手工对账
export function tradeByHand(data) {
    return request({
        url: '/pay/trade-recon/trade-by-hand',
        method: 'post',
        data: data
    })
}
//账户管理-退款管理条件查询
export function queryRefundList(data) {
    return request({
        url: '/pay/refund-manage/query-refund-list',
        method: 'post',
        data: data
    })
}
//账户管理-退款详情查询
export function queryRefundDetail(data) {
    return request({
        url: '/pay/refund-manage/query-refund-detail',
        method: 'post',
        data: data
    })
}
//账户管理-退款
export function accountManRefund(data) {
    return request({
        url: '/pay/refund-manage/refund',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-分页菜单列表
export function queryAppMenu(data) {
    return request({
        url: '/base/back-menu/query-menu',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-根据ID查询菜单
export function queryAppById(data) {
    return request({
        url: '/base/back-menu/query-by-id',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-新增数据
export function backMenuAdd(data) {
    return request({
        url: '/base/back-menu/add',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-删除数据
export function deleteMenuById(data) {
    return request({
        url: '/base/back-menu/delete-by-id',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-编辑数据
export function updateMenu(data) {
    return request({
        url: '/base/back-menu/update-menu',
        method: 'post',
        data: data
    })
}
//小程序首页菜单-排序
export function sortById(data) {
    return request({
        url: '/base/back-menu/sort-by-id',
        method: 'post',
        data: data
    })
}
//订单管理-订单管理条件查询
export function queryOrderList(data) {
    return request({
        url: '/pay/order/query-order-list',
        method: 'post',
        data: data
    })
}
//订单管理-客户订单详情查询
export function queryOrderDetail(data) {
    return request({
        url: '/pay/order/query-order-detail',
        method: 'post',
        data: data
    })
}
//订单管理-批量关闭
export function batchConfirmOrder(data) {
    return request({
        url: '/pay/order/batch-confirm-order',
        method: 'post',
        data: data
    })
}
//订单管理-关闭
export function handelOrder(data) {
    return request({
        url: '/pay/order/handel-order',
        method: 'post',
        data: data
    })
}
//参数配置-订单设置
export function setTimeOut(data) {
    return request({
        url: '/pay/order/set-time-out',
        method: 'post',
        data: data
    })
}
//工作台-全部
export function queryTableAll(data) {
    return request({
        url: '/packg/goodsInfo/query-table-all',
        method: 'post',
        data: data
    })
}
//工作台-交付分析
export function deliveryAnalysis(data) {
    return request({
        url: '/packg/goodsInfo/delivery-analysis',
        method: 'post',
        data: data
    })
}
//工作台-订单分析
export function orderAnalyst(data) {
    return request({
        url: '/pay/order/order-analyst',
        method: 'post',
        data: data
    })
}
//黑名单-客户分页查询
export function queryNoReg(data) {
    return request({
        url: '/base/custom/query-no-reg',
        method: 'post',
        data: data
    })
}
//查询标签实体列表
export function labelList(data) {
    return request({
        url: '/label/query-list',
        method: 'post',
        data: data
    })
}
//新增标签实体
export function labelAdd(data) {
    return request({
        url: '/label/add',
        method: 'post',
        data: data
    })
}
//分页查询标签列表
export function labelQuery(data) {
    return request({
        url: '/label/list/query-list',
        method: 'post',
        data: data
    })
}
//删除标签实体
export function labelDelete(data) {
    return request({
        url: '/label/delete-by-id',
        method: 'post',
        data: data
    })
}
//查询标签实体详情
export function labelQueryId(data) {
    return request({
        url: '/label/query-by-id',
        method: 'post',
        data: data
    })
}
//修改标签实体
export function labelUpdate(data) {
    return request({
        url: '/label/update',
        method: 'post',
        data: data
    })
}
//新增标签列表
export function labelListAdd(data) {
    return request({
        url: '/label/list/add',
        method: 'post',
        data: data
    })
}
//删除标签列表
export function labelDeleteId(data) {
    return request({
        url: '/label/list/delete-by-id',
        method: 'post',
        data: data
    })
}
//修改标签列表
export function labelListUpdate(data) {
    return request({
        url: '/label/list/update',
        method: 'post',
        data: data
    })
}
//查询标签列表详情
export function labelListId(data) {
    return request({
        url: '/label/list/query-by-id',
        method: 'post',
        data: data
    })
}
//批量启用
export function labelListEnable(data) {
    return request({
        url: '/label/list/enable',
        method: 'post',
        data: data
    })
}
//批量禁用
export function labelListDisable(data) {
    return request({
        url: '/label/list/disable',
        method: 'post',
        data: data
    })
}
//分页查询会员列表
export function queryMemberList(data) {
    return request({
        url: '/account/query-member-list',
        method: 'post',
        data: data
    })
}
//会员管理-新增会员
export function addMember(data) {
    return request({
        url: '/account/add-member',
        method: 'post',
        data: data
    })
}
//会员管理-查看详情
export function queryMemberInfo(data) {
    return request({
        url: '/account/query-member-info',
        method: 'post',
        data: data
    })
}
//会员管理-修改会员
export function undateMember(data) {
    return request({
        url: '/account/update-member',
        method: 'post',
        data: data
    })
}
//会员管理-修改会员
export function deleteMember(data) {
    return request({
        url: '/account/delete-member',
        method: 'post',
        data: data
    })
}
//套餐管理-分页查询会员列表
export function pkQueryList(data) {
    return request({
        url: '/packg/pk-manage/query-list',
        method: 'post',
        data: data
    })
}
//套餐管理-根据ID查询套餐
export function pkDeleteByid(data) {
    return request({
        url: '/packg/pk-manage/delete-by-id',
        method: 'post',
        data: data
    })
}
//商品管理-查询分类下的商品
export function goodsInfoTypeInfo(data) {
    return request({
        url: '/packg/goodsInfo/query-type-info',
        method: 'post',
        data: data
    })
}
//套餐管理-计算价格
export function pkComputePrice(data) {
    return request({
        url: '/packg/pk-manage/compute-price',
        method: 'post',
        data: data
    })
}
//套餐管理-新增套餐
export function pkAddPack(data) {
    return request({
        url: '/packg/pk-manage/add-pack',
        method: 'post',
        data: data
    })
}

//实体卡信息-新增
export function addPhyCard(data) {
    return request({
        url: '/phy/card/add-card',
        method: 'post',
        data: data
    })
}
//实体卡信息-修改
export function updatePhyCard(data) {
    return request({
        url: '/phy/card/update-card',
        method: 'post',
        data: data
    })
}
//实体卡信息-删除
export function delPhyCard(data) {
    return request({
        url: '/phy/card/delete-by-id',
        method: 'post',
        data: data
    })
}
//实体卡信息-详情查询
export function detailPhyCard(data) {
    return request({
        url: '/phy/card/query-by-id',
        method: 'post',
        data: data
    })
}
//实体卡信息-列表查询
export function queryPhyCard(data) {
    return request({
        url: '/phy/card/query-card-info',
        method: 'post',
        data: data
    })
}

//套餐管理-根据ID查询套餐
export function pkQueryById(data) {
    return request({
        url: '/packg/pk-manage/query-by-id',
        method: 'post',
        data: data
    })
}
//套餐管理-修改套餐
export function pkUpdatePack(data) {
    return request({
        url: '/packg/pk-manage/update-pack',
        method: 'post',
        data: data
    })
}
//查询实体卡管理列表
export function queryCardInfo(data) {
    return request({
        url: '/phy/order/query-card-info',
        method: 'post',
        data: data
    })
}
//新增实体卡管理
export function addCardManager(data) {
    return request({
        url: '/phy/order/add-card-manager',
        method: 'post',
        data: data
    })
}
//删除实体卡管理
export function deleteCardById(data) {
    return request({
        url: '/phy/order/delete-by-id',
        method: 'post',
        data: data
    })
}
//导入实体卡管理
export function importPhy(data) {
    return request({
        url: '/phy/order/import-phy',
        method: 'post',
        data: data
    })
}
//根据ID查询实体卡管理
export function queryCardById(data) {
    return request({
        url: '/phy/order/query-by-id',
        method: 'post',
        data: data
    })
}
//修改实体卡管理
export function updateCardManager(data) {
    return request({
        url: '/phy/order/update-card-manager',
        method: 'post',
        data: data
    })
}
//分页查询档案列表
export function queryFamily(data) {
    return request({
        url: '/family/query-family',
        method: 'post',
        data: data
    })
}
//删除档案
export function deleteFamilyById(data) {
    return request({
        url: '/family/delete-by-id',
        method: 'post',
        data: data
    })
}
//修改订单物流
export function updateLogistics(data) {
    return request({
        url: '/packg/logistics/update-logistics',
        method: 'post',
        data: data
    })
}
//分页查询账户列表
export function queryAccountList(data) {
    return request({
        url: '/account/query-account-list',
        method: 'post',
        data: data
    })
}
//账户充值/退款
export function topupAccount(data) {
    return request({
        url: '/account/topup-account',
        method: 'post',
        data: data
    })
}
//充值/退款账户详情
export function accountDetail(data) {
    return request({
        url: '/account/account-detail',
        method: 'post',
        data: data
    })
}
//客户权益赠予查询
export function queryGift(data) {
    return request({
        url: '/packg/apply/query-gift',
        method: 'post',
        data: data
    })
}

//获取绑卡信息
export function toGiftBindCard(data) {
    return request({
        url: '/packg/apply/toGiftBindCard',
        method: 'post',
        data: data
    })
}
//绑卡
export function giftBindCard(data) {
    return request({
        url: '/packg/apply/giftBindCard',
        method: 'post',
        data: data
    })
}

//查询所有员工
export function queryEmp(data) {
    return request({
        url: '/base/user/query-emp',
        method: 'post',
        data: data
    })
}
//派单
export function addProgressDisp(data) {
    return request({
        url: '/packg/service-progress/add-progress-disp',
        method: 'post',
        data: data
    })
}
//增加服务进度
export function addProgress(data) {
    return request({
        url: '/packg/service-progress/add-progress',
        method: 'post',
        data: data
    })
}

//查询服务进度
export function queryProgress(data) {
    return request({
        url: 'packg/service-progress/query-progress',
        method: 'post',
        data: data
    })
}

//查询意见反馈
export function queryFeedBack(data) {
    return request({
        url: 'base/feed/query-feed-back',
        method: 'post',
        data: data
    })
}

//查询服务提醒列表
export function queryRemind(data) {
    return request({
        url: 'service/remind/query-list',
        method: 'post',
        data: data
    })
}
//查询服务提醒列表
export function getCustName(data) {
    return request({
        url: 'base/custom/get-cust-name',
        method: 'post',
        data: data
    })
}

//客户权益赠予-去发货
export function toSendLogistics(data) {
    return request({
        url: 'packg/apply/toSendLogistics',
        method: 'post',
        data: data
    })
}
//客户权益赠予-发货
export function sendLogistics(data) {
    return request({
        url: 'packg/apply/sendLogistics',
        method: 'post',
        data: data
    })
}
//客户权益赠予-详情
export function giftDetail(data) {
    return request({
        url: 'packg/apply/gift-detail',
        method: 'post',
        data: data
    })
}
//服务新增标签
export function addRecLabel(data) {
    return request({
        url: 'label/list/add-rec-label',
        method: 'post',
        data: data
    })
}
//服务新增标签
export function deleteRecLabel(data) {
    return request({
        url: 'label/list/delete-rec-label',
        method: 'post',
        data: data
    })
}
//查询指定用户服务列表
export function queryRecByCust(data) {
    return request({
        url: 'packg/goodsInfo/query-rec-by-cust',
        method: 'post',
        data: data
    })
}
//文件下载-传文件地址(会员)
export function downloadAccount(data) {
    return request({
        url: `account/download-account`,
        method: 'get',
        responseType: 'blob',
    })
}
//导入会员excel
export function importAccount(data) {
    return request({
        url: 'account/import-account',
        method: 'post',
        data: data
    })
}
//批量导入会员
export function addBatchMember(data) {
    return request({
        url: 'account/add-batch-member',
        method: 'post',
        data: data
    })
}
//批量导入会员
export function queryFamilyById(data) {
    return request({
        url: 'family/query-by-id',
        method: 'post',
        data: data
    })
}
//文件下载-传文件地址(实体卡)
export function downloadPhy() {
    return request({
        url: `phy/order/download-phy`,
        method: 'get',
        responseType: 'blob',
    })
}
//意见反馈详情
export function detailFeedBack(data) {
    return request({
        url: 'base/feed/detail-feed-back',
        method: 'post',
        data: data
    })
}
//意见反馈详情
export function batchImportPhy(data) {
    return request({
        url: 'phy/order/batch-import-phy',
        method: 'post',
        data: data
    })
}